import React from 'react';
import { Platform } from '../web/react-native';
import styled from './styled';

import * as Colors from '../helpers/Colors';
import { IconButton } from './paper';

interface NavBarProps {
  title: string;
  leftButton?: React.ReactElement;
  rightButton?: React.ReactElement;
}

export const NavBar = ({ title, leftButton, rightButton }: NavBarProps) => {
  return (
    <Background>      
      {leftButton ?? <Spacer />}
      <NavTitle>{title}</NavTitle>
      {rightButton ?? <Spacer />}
    </Background>
  );
};

interface NavTextButtonProps {
  text: string;
  onPress: () => void;
  disabled?: boolean;
}

export const NavTextButton = ({ text, onPress, disabled }: NavTextButtonProps) => {
  const handleButtonPressed = () => {
    if (!disabled) {
      onPress();
    }
  };

  return (
    <TextButtonContainer onPress={handleButtonPressed}>
      <Spacer />
      <ButtonText disabled={disabled}>{text}</ButtonText>
      <Spacer />
    </TextButtonContainer>
  );
};

export const NavIconButton = styled(IconButton).attrs({
  color: 'white',
  rippleColor: 'transparent',
  size: 35,
})`
  flex: 1;
  align-items: center;
`;

const Background = styled.View`  
  display: flex;
  flex-direction: row !important;
  justify-content: space-between;
  align-items: center;min-height: 47px !important;
`;

const Spacer = styled.View`
  flex: 1;
`;

const ButtonText = styled.Text<{ disabled?: boolean }>`
  color: ${(props) => (props.disabled ? Colors.disabledButton : '#fff')};
  font-size: 18px;
  align-self: center;
`;

const TextButtonContainer = styled.TouchableOpacity`
  display: flex;
  align-items: center;
  flex: 1;
`;

const NavTitle = styled.Text`
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  align-self: center;
  text-align: center;
  flex: 3;
`;
